import * as React from 'react';
import { storyblokEditable } from '@storyblok/react';
import type { SbBlokData } from '@storyblok/react';

import type { PillarCardStoryblok } from '../../types/storyblok';

interface PillarCardProps {
  blok: PillarCardStoryblok;
}

/**
 * PillarCard displays a strategic pillar with an icon and description.
 * Used within MediaText "Our Mission" sections.
 *
 * Design: 64x64 icon left, description text right.
 * Desktop: 461px fixed width. Mobile: full width.
 * Hover: blue border with blue shadow.
 */
export const PillarCard: React.FC<PillarCardProps> = ({ blok }) => {
  const iconSrc = blok.icon?.filename;

  return (
    <div
      {...storyblokEditable(blok as unknown as SbBlokData)}
      className="flex items-center gap-4 p-4 bg-white border border-gray-300 rounded-lg transition-all hover:border-brand-blue hover:shadow-[0_4px_64px_0_rgba(13,79,160,0.16)]"
    >
      {iconSrc && (
        <div className="shrink-0 w-16 h-16 flex items-center justify-center">
          <img
            src={iconSrc}
            alt=""
            width={64}
            height={64}
            className="w-full h-full object-contain"
          />
        </div>
      )}
      <p className="flex-1 text-body3 text-gray-600">{blok.description}</p>
    </div>
  );
};
